import { M8AuthorizationType } from 'services/production/types';
import { UserAuthProvider } from 'types/state';
import { UnreachableError } from 'utils/errors';

export const normalizeM8AuthorizationType = (
  m8AuthorizationType: M8AuthorizationType
) => ({
  toUserAuthProvider(): UserAuthProvider {
    switch (m8AuthorizationType) {
      case 'BY_EMAIL':
        return 'EMAIL';
      case 'GOOGLE':
        return 'GOOGLE';
      default:
        throw new UnreachableError(m8AuthorizationType);
    }
  },
});
